<template>
  <div style="display: contents">
    <div
      class="rbu-fluctuation-module rbu-item-module-table-row no-border"
      style="margin-bottom: 1rem"
    >
      <div class="rbu-item-module-row-column-1">
        {{ idx === 0 ? "Census Rate" : "" }}
      </div>
      <div class="rbu-item-module-row-column-2">
        <div class="rbu-fluctuation-module-row-datapoint">
          <RbuPeriodInput
            outlined
            dense
            hide-details
            :value="fluctuation.current_period"
            @input="onPeriodUpdate($event, 'current')"
            :disabled="idx === 0"
            :eventMonths="current_period_event"
          ></RbuPeriodInput>
          <RbuDatapointInput
            dataset-type="RBU"
            :period="currentPeriod"
            :value="fluctuation.current_datapoint"
            @input="onDatapointUpdate(fluctuation.previous_datapoint, $event)"
          ></RbuDatapointInput>
          <div class="rbu-section-fluctuation-module-row-datapoint-label">
            {{ idx + 1 }}A
          </div>
        </div>
      </div>
      <div class="rbu-item-module-row-column-3"></div>
      <div class="rbu-item-module-row-column-value"></div>
      <div class="rbu-item-module-row-column-multiplier">
        {{ subTotalPercentage }}
      </div>
      <div class="rbu-item-module-row-column-formula">
        <!--        <div class="rbu-fluctuation-module-row-formula-wrapper">-->
        <!--          <v-text-field outlined-->
        <!--                        dense-->
        <!--                        hide-details-->
        <!--                        :value="formulaPrefix"-->
        <!--                        @input="onFormulaUpdate($event, formulaSuffix)"></v-text-field>-->
        <!--          <div class="rbu-fluctuation-module-row-formula-rate">Rate {{ subTotalPercentage ? `(${subTotalPercentage})` : '' }}</div>-->
        <!--          <v-text-field outlined-->
        <!--                        dense-->
        <!--                        hide-details-->
        <!--                        :value="formulaSuffix"-->
        <!--                        @input="onFormulaUpdate(formulaPrefix, $event)"></v-text-field>-->
        <!--        </div>-->
      </div>
      <div class="rbu-item-module-row-column-descriptions">
        <v-textarea
          outlined
          auto-grow
          rows="1"
          dense
          hide-details
          placeholder="Description"
          :value="fluctuation.current_descriptions"
          @input="onUpdate({ current_descriptions: $event })"
        ></v-textarea>
      </div>
      <div class="rbu-item-module-row-column-actions">
        <v-btn icon color="primary" @click="$emit('delete')">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
    </div>
    <div
      class="rbu-fluctuation-module rbu-item-module-table-row no-border no-top-margin"
    >
      <div class="rbu-item-module-row-column-1"></div>
      <div class="rbu-item-module-row-column-2">
        <div class="rbu-fluctuation-module-row-datapoint">
          <RbuPeriodInput
            outlined
            dense
            hide-details
            :value="fluctuation.previous_period"
            @input="onPeriodUpdate($event, 'previous')"
            :eventMonths="prev_period_event"
          ></RbuPeriodInput>
          <RbuDatapointInput
            dataset-type="RBU"
            :period="previousPeriod"
            :value="fluctuation.previous_datapoint"
            @input="onDatapointUpdate($event, fluctuation.current_datapoint)"
          ></RbuDatapointInput>
          <div class="rbu-section-fluctuation-module-row-datapoint-label">
            {{ idx + 1 }}B
          </div>
        </div>
      </div>
      <div class="rbu-item-module-row-column-3"></div>
      <div class="rbu-item-module-row-column-value"></div>
      <div class="rbu-item-module-row-column-multiplier"></div>
      <div class="rbu-item-module-row-column-formula">
        <!--        <div class="rbu-fluctuation-module-row-formula-wrapper">-->
        <!--          <v-text-field outlined-->
        <!--                        dense-->
        <!--                        hide-details-->
        <!--                        :value="formulaPrefix"-->
        <!--                        @input="onFormulaUpdate($event, formulaSuffix)"></v-text-field>-->
        <!--          <div class="rbu-fluctuation-module-row-formula-rate">Rate {{ subTotalPercentage ? `(${subTotalPercentage})` : '' }}</div>-->
        <!--          <v-text-field outlined-->
        <!--                        dense-->
        <!--                        hide-details-->
        <!--                        :value="formulaSuffix"-->
        <!--                        @input="onFormulaUpdate(formulaPrefix, $event)"></v-text-field>-->
        <!--        </div>-->
      </div>
      <div class="rbu-item-module-row-column-descriptions">
        <v-textarea
          outlined
          auto-grow
          rows="1"
          dense
          hide-details
          placeholder="Description"
          :value="fluctuation.previous_descriptions"
          @input="onUpdate({ previous_descriptions: $event })"
        ></v-textarea>
      </div>
      <div class="rbu-item-module-row-column-actions"></div>
    </div>
  </div>
</template>
<script>
import RbuAdjustment from "@/components/rbu/RbuAdjustment.vue";
import RbuPeriodInput from "@/components/rbu/RbuPeriodInput.vue";
import RbuDatapointInput from "@/components/rbu/RbuDatapointInput.vue";
import { computed, inject, onMounted, ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import floatingPointFix from "js-floating-point";

export default {
  name: "RbuFluctuation",
  props: {
    fluctuation: Object,
    idx: Number,
  },
  components: {
    RbuDatapointInput,
    RbuPeriodInput,
    RbuAdjustment,
  },
  setup(props, { root, emit }) {
    const item = inject("RBU_ITEM");
    const latest = inject("RBU_EDITION_LATEST");
    const base_start = inject("RBU_EDITION_BASE_START");
    const base_end = inject("RBU_EDITION_BASE_END");

    const current_period_event = ref([]);
    const prev_period_event = ref([]);

    const subTotalPercentage = computed(() => {
      if (
        props.fluctuation.previous_datapoint &&
        props.fluctuation.current_datapoint
      ) {
        let p = floatingPointFix(
          (parseFloat(props.fluctuation.current_datapoint.value) /
            parseFloat(props.fluctuation.previous_datapoint.value)) *
            100
        );
        p = Math.round(floatingPointFix(p * 100)) / 100;

        return p + "%";
      }
      return "";
    });

    const formulaPrefix = computed(() => {
      const components = (props.fluctuation.formula || "").split("{{VALUE}}");

      if (components.length === 2) {
        return components[0];
      }
      return "";
    });
    const formulaSuffix = computed(() => {
      const components = (props.fluctuation.formula || "").split("{{VALUE}}");

      if (components.length === 2) {
        return components[1];
      }
      return "";
    });
    const onFormulaUpdate = function (prefix, suffix) {
      onUpdate({ formula: `${prefix}{{VALUE}}${suffix}` });
    };

    const previousPeriod = computed(() => {
      if (item) {
        if (
          ["LATEST", "BASE_START", "BASE_END"].indexOf(
            props.fluctuation.previous_period
          ) !== -1
        ) {
          return (
            {
              LATEST: latest.value,
              BASE_START: base_start.value,
              BASE_END: base_end.value,
            }[props.fluctuation.previous_period] || ""
          );
        } else {
          return props.fluctuation.previous_period;
        }
      }
      return null;
    });
    const currentPeriod = computed(() => {
      if (item) {
        if (
          ["LATEST", "BASE_START", "BASE_END"].indexOf(
            props.fluctuation.current_period
          ) !== -1
        ) {
          return (
            {
              LATEST: latest.value,
              BASE_START: base_start.value,
              BASE_END: base_end.value,
            }[props.fluctuation.current_period] || ""
          );
        } else {
          return props.fluctuation.current_period;
        }
      }
      return null;
    });

    const onPeriodUpdate = async function (period, key) {
      console.debug("onPeriodUpdate", period, key);
      let d = {
        [`${key}_period`]: period,
      };

      let newPeriod =
        {
          LATEST: latest.value,
          BASE_START: base_start.value,
          BASE_END: base_end.value,
        }[period] || period;
      let datapoint = props.fluctuation[`${key}_datapoint`];
      if (newPeriod && datapoint && datapoint.period !== newPeriod) {
        // Try getting the new datapoint
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/dataset/datapoint/",
          params: {
            filters: {
              period: [newPeriod],
              dataset: [datapoint.dataset.id],
              type: [datapoint.type],
            },
            page_size: -1,
          },
        });

        if (response.body.success && response.body.points.length === 1) {
          d[`${key}_datapoint`] = response.body.points[0];
        } else {
          d[`${key}_datapoint`] = null;
        }
      }

      onUpdate(d);
    };
    const onDatapointUpdate = async function (
      previous_datapoint,
      current_datapoint
    ) {
      let updates = {
        previous_datapoint,
        current_datapoint,
      };

      let previous_period =
        {
          LATEST: latest.value,
          BASE_START: base_start.value,
          BASE_END: base_end.value,
        }[props.fluctuation.previous_period] ||
        props.fluctuation.previous_period;
      if (
        previous_datapoint &&
        typeof previous_datapoint === "object" &&
        previous_datapoint.period !== previous_period
      ) {
        updates["previous_period"] = previous_datapoint.period;
        previous_period = previous_datapoint.period;
      }

      let current_period =
        {
          LATEST: latest.value,
          BASE_START: base_start.value,
          BASE_END: base_end.value,
        }[props.fluctuation.current_period] || props.fluctuation.current_period;
      if (
        current_datapoint &&
        typeof current_datapoint === "object" &&
        current_datapoint.period !== current_period
      ) {
        updates["current_period"] = current_datapoint.period;
        current_period = current_datapoint.period;
      }

      if (!previous_datapoint && typeof current_datapoint === "object") {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/dataset/datapoint/",
          params: {
            filters: {
              period: [previous_period],
              dataset: [current_datapoint.dataset.id],
              type: [current_datapoint.type],
            },
            page_size: -1,
          },
        });

        if (response.body.success && response.body.points.length === 1) {
          updates.previous_datapoint = response.body.points[0];
        }
      } else if (!current_datapoint && typeof previous_datapoint === "object") {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/dataset/datapoint/",
          params: {
            filters: {
              period: [current_period],
              dataset: [previous_datapoint.dataset.id],
              type: [previous_datapoint.type],
            },
            page_size: -1,
          },
        });

        if (response.body.success && response.body.points.length === 1) {
          updates.current_datapoint = response.body.points[0];
        }
      }

      if (updates.current_datapoint) {
        getAvailablePeriod(updates.current_datapoint, "current");
      } else {
        current_period_event.value = [];
      }

      if (updates.previous_datapoint) {
        getAvailablePeriod(updates.previous_datapoint, "prev");
      } else {
        prev_period_event.value = [];
      }
      onUpdate(updates);
    };

    const getAvailablePeriod = async function (dp, type) {
      if (!dp) return;
      if (!dp.id) return;
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/datapoint/available_data_period/",
        params: {
          dp_id: dp.id,
        },
      });

      let events = [];
      if (response && response.data && response.data.success) {
        events = response.data.periods || [];
      }

      if (type === "current") {
        current_period_event.value = events;
      } else if (type === "prev") {
        prev_period_event.value = events;
      }
    };

    const onUpdate = _.debounce(function (evt) {
      console.debug("Fluctuation Update: ", evt);

      let updates = {
        ...props.fluctuation,
        ...evt,
      };

      if (updates.previous_datapoint && updates.current_datapoint) {
        let sub_total =
          parseFloat(updates.current_datapoint.value) /
          parseFloat(updates.previous_datapoint.value);

        sub_total = floatingPointFix(sub_total);
        sub_total = Math.round(floatingPointFix(sub_total * 1000000)) / 1000000;

        if (updates.formula) {
          try {
            sub_total = floatingPointFix(
              parseFloat(eval(updates.formula.replace("{{VALUE}}", sub_total)))
            );
            sub_total = Math.round(floatingPointFix(sub_total * 10000)) / 10000;
          } catch (e) {
            console.debug(e);
          }
        }

        updates.sub_total = sub_total;
      }

      emit("update", updates);
    }, 500);

    onMounted(async () => {
      if (props.fluctuation && props.fluctuation.current_datapoint) {
        getAvailablePeriod(props.fluctuation.current_datapoint, "current");
      }

      if (props.fluctuation && props.fluctuation.previous_datapoint) {
        getAvailablePeriod(props.fluctuation.previous_datapoint, "prev");
      }
    });

    return {
      subTotalPercentage,
      formulaPrefix,
      formulaSuffix,
      onFormulaUpdate,
      previousPeriod,
      currentPeriod,
      onPeriodUpdate,
      onDatapointUpdate,
      onUpdate,
      current_period_event,
      prev_period_event,
    };
  },
};
</script>

<style lang="less">
.rbu-fluctuation-module {
  padding: 0;

  &.no-top-margin {
    margin-top: -32px;
  }

  .rbu-fluctuation-module-row-datapoint {
    padding: 8px 0;
    display: flex;
    gap: 8px;
  }

  .rbu-fluctuation-module-row-formula-wrapper {
    display: flex;
    gap: 10px;
    align-items: center;

    .rbu-fluctuation-module-row-formula-rate {
      background-color: rgba(167, 18, 23, 1);
      color: white;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.15px;
      text-align: left;

      padding: 4px;
      gap: 10px;
      border-radius: 8px;
    }

    .rbu-fluctuation-module-row-formula-times {
      width: 24px;
      height: 24px;
      padding: 0 8px;
      gap: 10px;
      border-radius: 16px;
      background-color: rgba(255, 222, 48, 1);
    }
  }
}
</style>
